<template>
	<div class="longWriter">
<!-- max-h-[600px]  overflow-y-auto -->
        <div class='long-content  overflow-hidden   outline-container pt-[10px]' >
          <div class="">
            <div class="flex outline-row outline-row-title" >
              <div class="flex min-w-[60px] minHeight">
                <div class="w-12 min-w-12 text-right text-xs text-gray-400 relative top-3">标题</div>
                <div class="ml-2 relative">
                  <div class="w-[7px] h-[7px] rounded-full bg-gray-200 absolute left-[-3px] top-4"></div>
                  <div class="w-[1px] h-full bg-gray-200 relative" style="top: 16px;"></div>
                </div>
              </div>
              <div class="flex-1 ml-2 outline-content   rounded-lg p-1 mb-1 whitespace-nowrap" tabindex="0">
                <div class="text-sm block font-semibold truncate cursor-text" :title="dataList.content?.title">{{ dataList.content?.title}}</div>
              </div>
            </div>
            <template v-if="dataList.chidren?.length > 0" v-for="(item, index) in dataList.chidren" :key="index">
              <div class="flex outline-row"  >
              <div class="flex min-w-[60px]">
                <div class="w-12 min-w-12 text-right text-xs text-gray-400 relative top-3">第{{index + 1}}章</div>
                <div class="ml-2 relative">
                  <div class="w-[7px] h-[7px] rounded-full bg-gray-200 absolute left-[-3px] top-4"></div>
                  <div class="w-[1px] h-full bg-gray-200 relative"></div>
                </div>
              </div>
              <div class="flex-1 ml-2 outline-content   rounded-lg p-1 mb-1 whitespace-nowrap editInput"   tabindex="0">
                <div class="text-sm block font-semibold truncate cursor-text">
                  {{ item.content?.title == "" ? "请输入标题" : item.content?.title }}
                </div>
                <div class="flex items-center justify-between">
                  <div :title="item.content.desc" class="text-[#999] text-[13px] mt-1px block cursor-text truncate">
                    {{ item.content?.desc }}
                </div>
                </div>
              </div>

              </div>

              <template v-if="item.chidren && item.chidren.length > 0" v-for="(itemC, indexC) in item.chidren" :key="indexC">
              <div class="flex outline-row" >
                <div class="flex">
                  <div class="w-12 min-w-12 text-right text-xs text-gray-400 relative top-3">{{index + 1}}.{{ indexC + 1 }}</div>
                  <div class="ml-2 relative">
                    <div class="w-[1px] h-full bg-gray-200 relative"></div>
                  </div>
                  <div>
                    <div class="w-3 h-[1px] bg-gray-200 relative top-L"></div>
                    <div class="w-1.5 h-1.5 relative -right-3 top-3.5 rounded-full border border-gray-200 border-solid"></div>
                  </div>
                </div>
                <div class="flex-1 ml-2 outline-content   rounded-lg p-1 mb-1 whitespace-nowrap editInput" tabindex="0"  >
                  <!-- <w-textarea v-if="itemC.edit" auto-size class="outline-input text-sm block font-semibold truncate" v-model="itemC.content.title" placeholder="请输入标题" /> -->
                  <div class="text-sm block font-semibold truncate cursor-text">
                    {{ itemC.content.title == "" ? "请输入标题" : itemC.content.title }}
                  </div>
                  <div class="flex items-center justify-between">
                    <div :title="itemC.content.desc" class="text-[#999] text-[13px] mt-[1px] block cursor-text truncate">{{ itemC.content.desc }}</div>
                  </div>
                </div>
                
              </div>
              </template>
            </template>
          </div>
        </div>

	</div>
</template>
 
<script setup lang="ts">
import { ref, onMounted, toRefs, computed, nextTick,watch, defineAsyncComponent,onBeforeUnmount, onUnmounted} from 'vue';

const props = defineProps<{
  dataList: {};   //子组件接收
}>()
//解构赋值
const { dataList } = toRefs(props)






onMounted(() => {
  // dataList.value = JSON.parse(dataList.value)
})

onUnmounted(() => {
});

const innerHeight = ref(1000)
const onResize = () => {
  innerHeight.value = window.innerHeight
}


// 在组件卸载前清除定时器





</script>

  
<style scoped lang="scss">
.longWriter{
  :deep(.w-steps){
    // width: 300px;
    margin: 20px 0 30px 0;
    .w-steps-item-node{
      margin-left: 49px;
    }
    .w-steps-item-title{
      font-size: 12px;
    }
    .w-steps-item-content{
      width: 120px;
    }
    .w-steps-item-tail{
      left: 84px;
    }
  }
  .minHeight{
    min-height: 40px;
  }
  .content{
    padding: 0 20px;
    position: relative;
    .content-item{
      margin-bottom: 20px;
      .outlint-footer-btn{
        &:nth-child(2){
          color: #fff;
          box-shadow: 0px 6px 12px 0px rgba(20,77,200,0.2);
          background: linear-gradient( 270deg, #65B2FF 0%, #355EFF 100%);
        }
      }
      .title{
        font-size: 14px;
        color: #181B49;
        padding-left: 3px;
        margin-bottom: 5px;
        display:flex;
        align-items:center;
        position:relative;
        strong{
          position:absolute;
          display: inline-block;
          color: rgb(var(--danger-6));
          font-size: 6px;
          line-height: 1;
          margin-left: 3px;
          left: 32px;
          top: 6px;
        }
      }
      .file-wrap{
        width: 100%;
        height: 476px;
        height: 385px;
        border: 1px solid #DCDFE6;
        border-radius: 4px;
      }
      .fontSize{
        position: relative;
        bottom: 20px;
        // left: calc(100% - 80px);
        font-size: 12px;
        float: right;
        margin-right: 15px;
      }
    }
  }
  .w-textarea-wrapper{
    border: none;
    padding: 0px 0px 34px 0px;
  }
  .right-textarea.w-textarea-wrapper{
    border: 1px solid #DCDFE6!important;
    border-radius: 4px;
    padding-bottom: 0;
  }

  :deep(.w-textarea){
    height: 100%;
    resize: none;
  }
}
.top-L{
    top: 1.125rem
}
.creating-cont {
	text-align: center;
	margin: 50% auto;
	img {
		display: inline-block;
		margin: 0 auto;
	}
	.tip1 {
		font-size: 16px;
		color: #181b49;
		line-height: 24px;
		font-weight: bold;
		margin: 10px 0;
	}

	.tip2 {
		font-weight: 400;
		font-size: 14px;
		color: #c6c6d2;
		line-height: 19px;
		margin: 10px 0 20px;
	}
}
.createArticle {
  margin: 0 10px 0 22px;
  text-align: center;
  position: relative;
  top: 28%;
  p {
    font-size: 16px;
    font-weight: bold;
    color: #181b49;
    line-height: 24px;
  }

  .createHandler {
    margin-top: 42px;
    display: flex;
    justify-content: center;
    gap: 16px;

    button {
      width: 120px;
      height: 32px;
      border-radius: 4px;
    }
  }
}
.outline-content{
  outline: none;
  border: 1px solid transparent;
  max-width: calc(100% - 80px);
}
.outline-content--edit{
  background-color: transparent;
  border-color: #3763fe;
}
.outline-input{
  width: 100%;
  outline: none;
  border: none;
  padding: 0;
  background-color: transparent;
    :deep(.w-input){
      padding: 0 !important;
      line-height: initial;
    }
}
.outline-btns{
  opacity: 0;
  position: relative;
  top: -5px;
  cursor: pointer;
}
.outline-row:not(.outline-row-disable):hover .outline-btns{
  opacity: 1;
}
.outline-row:not(.outline-row-disable):hover .outline-content{
  background-color: #f2f4f7;
}
.outlint-footer-btn{
  flex: 1;
  height: 40px;
  line-height: 40px;
  color: #646479;
  border-radius: 8px 8px 8px 8px;
  border: 1px solid #E4E8EE;
  cursor: pointer;
  &:nth-child(3){
    color: #fff;
    box-shadow: 0px 6px 12px 0px rgba(20,77,200,0.2);
    background: linear-gradient( 270deg, #65B2FF 0%, #355EFF 100%);
  }
}



.loading-wrap {
    width: 100%
}

.loading-wrap .loading-bar {
    width: 100%;
    margin-bottom: 6px;
    border-radius: 4px;
    height: 15px;
    background: -webkit-linear-gradient(57deg,rgba(240,242,245,.2) 0,rgb(234,236,239) 25%,rgb(225,227,229) 50%,rgb(234,236,239) 75%,rgba(240,242,245,.2) 100%);
    background: linear-gradient(33deg,#f0f2f533 0,#eaecef,#e1e3e5,#eaecef,#f0f2f533);
    background-position: 0 0;
    background-size: 200% 100%;
    -webkit-animation: loading-animation-29510e21 2.15s linear infinite;
    animation: loading-animation-29510e21 2.15s linear infinite
}

.loading-wrap .loading-bar:first-child {
    -webkit-animation-delay: 0s;
    animation-delay: 0s
}

.loading-wrap .loading-bar:nth-child(2) {
    -webkit-animation-delay: .5s;
    animation-delay: .5s
}

.loading-wrap .loading-bar:nth-child(3) {
    -webkit-animation-delay: 1s;
    animation-delay: 1s
}

@-webkit-keyframes loading-animation-29510e21 {
    0% {
        background-position: 0 0
    }

    to {
        background-position: -200% 0
    }
}

@keyframes loading-animation-29510e21 {
    0% {
        background-position: 0 0
    }

    to {
        background-position: -200% 0
    }
}

.loading-container {
    -webkit-transform-origin: 0 0;
    -ms-transform-origin: 0 0;
    transform-origin: 0 0;
    -webkit-transform: scaleX(0);
    -ms-transform: scaleX(0);
    transform: scaleX(0);
    -webkit-animation-name: loading-fill-29510e21;
    animation-name: loading-fill-29510e21;
    -webkit-animation-duration: .72s;
    animation-duration: .72s;
    -webkit-animation-fill-mode: forwards;
    animation-fill-mode: forwards
}

.loading-container:first-child {
    -webkit-animation-delay: .05s;
    animation-delay: .05s
}

.loading-container:nth-child(2) {
    -webkit-animation-delay: .09s;
    animation-delay: .09s
}

.loading-container:nth-child(3) {
    -webkit-animation-delay: .24s;
    animation-delay: .24s;
    width: 66%
}

@-webkit-keyframes loading-fill-29510e21 {
    0% {
        -webkit-transform: scaleX(0);
        transform: scaleX(0)
    }

    to {
        -webkit-transform: scaleX(1);
        transform: scaleX(1)
    }
}

@keyframes loading-fill-29510e21 {
    0% {
        -webkit-transform: scaleX(0);
        transform: scaleX(0)
    }

    to {
        -webkit-transform: scaleX(1);
        transform: scaleX(1)
    }
}
</style>
<style lang="scss">
.pop-content-list {
	.w-popover-content {
		padding: 4px 0;
	}
	.pc-item {
		line-height: 36px;
		padding: 0 12px;
		overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
		cursor: pointer;
		&:hover {
			background-color: #F2F3F5;
		}
	}
	.item-active {
		background-color: #F2F3F5;
	}

}
</style>
